<div class="main">
  <div class="header">
    {{'FAVORITELOCATION.addLocTitle' | translate}}
    <i class="material-icons" (click)='closeDialog();'>clear</i>
  </div>
  <div class="section">
    
    <div class="mapSection">
      <div id="map" class="map">

      </div>
    </div>
    <div class="search">
      <input type="text" class="input" [placeholder]="'FAVORITELOCATION.searchArea' | translate" id="placesSearch">
    </div>
    <div class="form">
      <div class="left">
        <div class="inputSection">
          <div class="labels">
              <sup class="required">*</sup>{{'FAVORITELOCATION.entNameLab' | translate}}
          </div>
            <input type="text" [(ngModel)]="LocationData.name">
        </div>
        <div class="inputSection">
          <div class="labels">
              {{'FAVORITELOCATION.startTimeLab' | translate}}
          </div>
          <input type="text" [ngxTimepicker]="picker" [(ngModel)]="start">
          <ngx-material-timepicker class="timePick" #picker (closed)="setTime(start, false)"></ngx-material-timepicker>
        </div>
        <div class="inputSection">
            <div class="labels">
                <sup class="required">*</sup>{{'FAVORITELOCATION.contactPersonLab' | translate}}
            </div>
              <input type="text" [(ngModel)]="LocationData.contact_name">
          </div>
          <div class="inputSection">
              <div class="labels">
                <sup class="required">*</sup>{{'FAVORITELOCATION.mobileLab' | translate}}
              </div>
                <input type="text" [(ngModel)]="LocationData.mobile">
            </div>
      </div>
      <div class="right">

        <div class="inputSection">
            <div class="labels">
              {{'FAVORITELOCATION.landmarkLab' | translate}}
            </div>
              <input type="text" [(ngModel)]="LocationData.landmark">
          </div>
          <div class="inputSection">
            <div class="labels">
                {{'FAVORITELOCATION.finishTimeLab' | translate}}
            </div>
            <input type="text" [ngxTimepicker]="picker1" [(ngModel)]="end">
            <ngx-material-timepicker class="timePick" #picker1 (closed)="setTime(end)"></ngx-material-timepicker>
          </div>
          <div class="inputSection">
            <div class="labels">
              <sup class="required">*</sup>{{'FAVORITELOCATION.cityLab' | translate}}
            </div>
              <input type="text" [(ngModel)]="LocationData.city">
          </div>
          <div class="inputSection">
              <div class="labels">
                <sup class="required">*</sup>{{'FAVORITELOCATION.pincodeLab' | translate}}
              </div>
                <input type="text" [(ngModel)]="LocationData.pincode">
            </div>
      </div>
    </div>
    <div class="submitButton" (click)="closeDialog();">
      <div class="button" style="background-color: #939393;">
        {{'FAVORITELOCATION.closeButton' | translate}}
      </div>
    </div>
    <div class="submitButton" style="float: right" (click)="saveLocation();" >
        <div class="button">
          {{'FAVORITELOCATION.submitButton' | translate}}
        </div>
      </div>
  </div>
</div>
